export default __webpack_public_path__ + "static/media/Jones_01.13d247d4.jpg";